<template>
	<div>
		<q-form
			@submit.prevent="checkLogin()"
			v-if="$route.name != 'webservice-login' && $route.name != 'webservice-login-unauthenticated'"
		>
			<q-input
				outlined
				label-slot
				:dark="lightOrDark"
				type="text"
				class="text-lowercase"
				dense
				v-model="username"
				autocomplete="username"
				:error="v$.username.$error"
				@input="v$.username.$touch"
				v-if="showLoginCommands"
			>
				<template v-slot:label>
					<div class="text-capitalize">
						{{ $t('user') }}
					</div>
				</template>
			</q-input>

			<q-input
				outlined
				:dark="lightOrDark"
				dense
				v-model="password"
				autocomplete="current-password"
				:type="isPwd ? 'password' : 'text'"
				:label="$t('password')"
				:error="v$.password.$error"
				@input="v$.password.$touch"
				v-if="showLoginCommands"
			>
				<template v-slot:append>
					<q-icon
						:name="isPwd ? 'fal fa-eye-slash' : 'fal fa-eye'"
						class="cursor-pointer"
						@click="isPwd = !isPwd"
					/>
				</template>
			</q-input>

			<q-btn
				type="submit"
				color="primary"
				class="login-button full-width q-my-sm q-py-xs"
				:label="$t('sign_in')"
				v-if="showLoginCommands"
			/>

			<q-btn
				color="primary"
				class="login-button full-width q-my-sm q-py-xs"
				:label="$t('login_azure')"
				@click="loginAzure"
				v-if="show_azure_login_btn"
			/>

			<q-btn
				outline
				color="secondary"
				class="login-button full-width q-my-sm q-py-xs"
				:label="$t('sign_up')"
				@click="this.$router.push({ name: 'register' })"
				v-if="showRegister && showLoginCommands"
			/>

			<q-btn
				outline
				color="secondary"
				class="login-button full-width q-my-sm q-py-xs"
				:label="$t('sign_up')"
				@click="$router.push({ name: 'register-pop-trade' })"
				v-if="showPopTradeOauth"
			/>

			<q-btn
				outline
				color="secondary"
				class="login-button full-width q-my-sm q-py-xs"
				:label="$t('sign_up')"
				@click="$router.push({ name: 'register-seven-trade' })"
				v-if="showSevenTradeOauth"
			/>

			<div
				class="text-center text-weight-light q-mt-xl"
				v-if="register_fields.email_fields && showLoginCommands"
			>
				<q-btn
					outline
					color="negative"
					class="login-button q-my-sm q-py-xs"
					:label="$t('forgot_password')"
					@click="$router.push({ name: 'request_password' })"
				/>
				<q-btn
					v-if="hasSmsPasswordRecovery"
					flat
					class="login-button"
					icon="fal fa-question-circle"
					@click="show_forgot_password_help = true"
				/>
			</div>

			<!-- <div class="text-center text-weight-light q-mt-sm" v-if="projectfoder === 'edupine'">
				<router-link :to="{ name: 'first_access' }" class="text-blue-grey-5">
					{{ $t('first_access') }}
				</router-link>
			</div> -->

			<div
				class="text-faded text-center q-mb-sm q-mt-md"
				v-if="login_recaptcha"
				:style="$q.platform.is.mobile ? '' : 'font-size: 11px;'"
			>
				<div class="q-mb-sm">
					<span :class="$q.platform.is.mobile ? 'text-white' : 'text-black'"
						>{{ $t('this_site_is_protected_by_googles_recaptcha') }}.
					</span>
					<span :class="$q.platform.is.mobile ? 'text-white' : 'text-black'"
						>{{ $t('do_apply') }}
					</span>
				</div>
				<a class="text-secondary" href="https://policies.google.com/privacy" target="_blank">{{
					$t('privacy_policy')
				}}</a>
				<span :class="$q.platform.is.mobile ? 'text-white q-mx-sm' : 'text-black'">
					{{ ` ${$t('and')} ` }}
				</span>
				<a class="text-secondary" href="https://policies.google.com/terms" target="_blank">{{
					$t('terms_of_service')
				}}</a
				>.
			</div>

			<!-- <vue-recaptcha
                style="visibility: hidden;"
                ref="invisibleRecaptcha"
                @verify="checkVerify"
                size="invisible"
                :sitekey="recaptchaCode"
                :loadRecaptchaScript="true"
                badge="inline">
            </vue-recaptcha> -->
		</q-form>
		<h5 v-if="$route.name == 'webservice-login'" class="text-center">
			{{ $t('Please_wait_we_are_validating_your_access') }}
		</h5>
		<div v-if="$route.name == 'webservice-login-unauthenticated'">
			<p class="word-wrap">
				{{ $t('user_not_found_contact_to') }}
				<a :href="'mailto:' + support_email" class="underline text-bold">{{ support_email }}</a>
				{{ $t('to_request_to_access_on_the_platform') }}
			</p>
			<q-btn
				color="primary"
				class="login-button full-width q-my-sm q-py-xs"
				:label="$t('back')"
				@click="$router.push({ name: 'login' })"
			/>
		</div>

		<q-dialog v-model="show_forgot_password_help">
			<q-card>
				<q-card-section>
					<div class="text-h6">{{ $t('password_recovery') }}</div>
				</q-card-section>

				<q-card-section class="q-pt-none">
					<div>
						<p>
							<router-link :to="{ name: 'request_password' }" class="linkfix">
								<strong>{{ $t('click_here') }}</strong>
							</router-link>
							{{ $t('to_recover_your_password_using_email_or_sms') }}
						</p>
						<p v-if="register_fields.document">
							{{ $t('you_can_recover_your_password_using_your_email_or_document_or_sms') }}
						</p>
						<p v-else>{{ $t('you_can_recover_your_password_using_your_email_or_sms') }}</p>
						<p>
							{{ $t('doubts') }}
							<router-link :to="{ name: 'login_support' }" class="linkfix">
								<strong>{{ $t('click_here') }}</strong>
							</router-link>
						</p>
					</div>
				</q-card-section>

				<q-card-actions align="right">
					<q-btn flat label="OK" color="primary" v-close-popup></q-btn>
				</q-card-actions>
			</q-card>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getAuth, signInWithCustomToken } from 'firebase/auth/cordova'
import { required } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import { Plugins } from '@capacitor/core'
const { Storage } = Plugins

export default {
	name: 'LoginForm',

	props: ['is_modal'],

	setup() {
		return { v$: useVuelidate({ $scope: false }) }
	},

	data() {
		return {
			username: '',
			password: '',
			isPwd: true,
			custom_error_message: '',
			show_forgot_password_help: false,
			support_email: '',
		}
	},

	computed: {
		...mapGetters({
			accept_cookies: 'cookies_policy/accept_cookies',
			access_token: 'common/access_token',
			attempts: 'params/attempts',
			background: 'params/background',
			clients: 'params/clients',
			cookies_type: 'params/cookies_type',
			device_token: 'common/device_token',
			login_accept_document: 'params/login_accept_document',
			login_oauth2: 'params/oauth2',
			login_recaptcha: 'params/recaptcha',
			policy_modal: 'cookies_policy/policy_modal',
			redirect_token: 'redirect/token',
			redirect_url: 'common/redirect_url',
			register: 'params/register',
			register_fields: 'params/register_fields',
			register_store: 'params/register',
			user_pre_register: 'params/login_user_pre_register',
			user_register: 'params/login_user_register',
			show_azure_login_btn: 'params/show_azure_login_btn',
			login_config: 'params/login',
		}),

		showRegister() {
			if (
				this.user_pre_register ||
				(this.user_register &&
					!this.showPopTradeOauth &&
					!this.showSevenTradeOauth &&
					!this.showWebinarOauth)
			)
				return true
			else return false
		},

		showPopTradeOauth() {
			if (this.login_oauth2) {
				let obj = this.login_oauth2.find((obj) => {
					return obj.slug === 'academiapoptrade'
				})
				if (obj) return obj.is_active
			}
			return false
		},

		showSevenTradeOauth() {
			if (this.login_oauth2) {
				let obj = this.login_oauth2.find((obj) => obj.slug === 'academiaseventrade')
				if (obj) return obj.is_active
			}
			return false
		},

		showWebinarOauth() {
			if (this.login_oauth2) {
				let obj = this.login_oauth2.find((obj) => obj.slug === 'intelwebinar')
				if (obj) return obj.is_active
			}
			return false
		},

		lightOrDark() {
			if (this.background && this.$q.platform.is.mobile && !this.is_modal) {
				let color = this.background
				let r, g, b, hsp

				if (color.match(/^rgb/)) {
					color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)

					r = color[1]
					g = color[2]
					b = color[3]
				} else {
					color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'))

					r = color >> 16
					g = (color >> 8) & 255
					b = color & 255
				}

				hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

				if (hsp > 127.5) return false
				else return true
			} else return false
		},

		recaptchaCode() {
			return process.env.GOOGLE_RECAPCHA_KEY
		},

		forceError() {
			return process.env.PROJECT_NAME === 'CRM Play'
		},

		// projectfoder() {
		// 	return process.env.PROJECT_FOLDER
		// },

		hasSmsPasswordRecovery() {
			return this.register?.recover_password_with_sms
		},

		showLoginCommands() {
			return this.login_config?.use_login_commands
		},
	},

	methods: {
		checkLogin() {
			if (
				!this.accept_cookies &&
				!this.policy_modal &&
				!this.$q.platform.is.capacitor &&
				this.cookies_type !== 'onetrust' &&
				this.cookies_type !== 'cookiereports'
			) {
				this.$store.dispatch('cookies_policy/SET_POLICY', [true])
			} else {
				this.v$.$touch()
				if (!this.v$.$error) {
					this.$q.loading.show()

					if (this.login_recaptcha && this.attempts >= 3) {
						this.$q.loading.hide()
						this.$refs.invisibleRecaptcha.execute()
					} else {
						if (process.env.PROJECT_FOLDER === 'academiapoptrade') this.loginPopTrade()
						else if (process.env.PROJECT_FOLDER === 'academiaseventrade') this.loginSevenTrade()
						else if (process.env.PROJECT_FOLDER === 'edupine') this.loginEduPine()
						else this.login()
					}
				}
			}
		},

		checkVerify(response) {
			this.login(response)
		},

		login(google_token) {
			this.v$.$touch()
			if (!this.v$.$error) {
				this.$q.loading.show()

				let data = {
					grant_type: 'password',
					username: this.username.trim().toLowerCase(),
					password: this.password,
				}

				if (google_token) data.google_token = google_token

				let url = ''

				if (this.login_accept_document) {
					url = '/etraining_login/alternative_login/'
				} else {
					url = '/o/token/'
				}

				this.$axios
					.post(url, this.$qs.stringify(data))
					.then((response) => {
						if (this.$hasGtm && this.$gtm.enabled()) {
							this.$gtm.trackEvent({
								event: 'interaction',
								category: 'session',
								action: 'login',
								label: this.$route.path,
								value: 0,
								noninteraction: false,
							})
						}
						this.setUserData(response)
					})
					.catch((e) => {
						this.$q.loading.hide()

						if (e.response) {
							if (e.response.data.qty_login_attempts) {
								this.$store.dispatch('params/SET_ATTEMPTS', [e.response.data.qty_login_attempts])
							}
						}

						if (this.login_recaptcha && this.attempts >= 3) this.$refs.invisibleRecaptcha.reset()

						this.$q.notify({
							message: this.$t('error_logging_in_check_the_user_and_password_entered'),
							type: 'negative',
							icon: 'fal fa-ban',
						})

						console.log(e)
					})
			}
		},

		loginPopTrade() {
			if (this.login_oauth2) {
				let obj = this.login_oauth2.find((obj) => obj.slug === 'academiapoptrade')
				if (obj) {
					this.v$.$touch()

					if (!this.v$.$error) {
						this.$q.loading.show()

						let data = {
							grant_type: 'password',
							username: this.username.trim().toLowerCase(),
							password: this.password,
						}
						this.$axios
							.post(obj.oauth_url, data)
							.then((response) => {
								this.setUserData(response)
							})
							.catch((e) => {
								this.$q.loading.hide()
								this.custom_error_message = ''

								if (e.response.data.messages) {
									this.custom_error_message = `${e.response.data.owner} - ${e.response.data.messages[0]}`
								} else if (e.response.data.message) {
									this.custom_error_message = e.response.data.message
								}

								this.showCustomError()
								console.log(e)
							})
					}
				}
			}
		},

		loginSevenTrade() {
			if (this.login_oauth2) {
				let obj = this.login_oauth2.find((obj) => obj.slug === 'academiaseventrade')
				if (obj) {
					this.v$.$touch()

					if (!this.v$.$error) {
						this.$q.loading.show()

						let data = {
							grant_type: 'password',
							username: this.username.trim().toLowerCase(),
							password: this.password,
						}

						this.$axios
							.post(obj.oauth_url, data)
							.then((response) => {
								this.setUserData(response)
							})
							.catch((e) => {
								this.$q.loading.hide()
								this.custom_error_message = ''

								if (e.response.data.messages) {
									this.custom_error_message = `${e.response.data.owner} - ${e.response.data.messages[0]}`
								} else if (e.response.data.message) {
									this.custom_error_message = e.response.data.message
								}

								this.showCustomError()
								console.log(e)
							})
					}
				}
			}
		},

		loginEduPine() {
			this.v$.$touch()
			if (!this.v$.$error) {
				this.$q.loading.show()

				let data = {
					grant_type: 'password',
					username: this.username.trim().toLowerCase(),
					password: this.password,
				}

				this.$axios
					.post('webservices/edupine/login/', data)
					.then((response) => {
						if (response.status === 201) {
							this.$q.loading.hide()
							this.$q.notify({
								message: this.$t(
									'your_account_has_been_created_verify_your_email_for_instructions'
								),
								type: 'positive',
								icon: 'fal fa-check',
							})
						} else {
							this.setUserData(response)
						}
					})
					.catch((e) => {
						this.$q.loading.hide()
						this.custom_error_message =
							'error_logging_in_check_that_the_data_is_correct_if_you_still_can_t_get_it_contact_your_manage'
						this.showCustomError()
						console.log(e)
					})
			}
		},

		showCustomError() {
			this.$q.notify({
				message: this.custom_error_message
					? this.$t(this.custom_error_message)
					: this.$t('error_logging_in_check_the_user_and_password_entered'),
				type: 'negative',
				icon: 'fal fa-ban',
			})
		},

		async setUserData(response) {
			this.$store.dispatch('common/SET_ACCESS_TOKEN', [
				response.data.access_token,
				response.data.refresh_token,
				response.data.user_firebase_token,
			])

			if (response.data.user_firebase_token) {
				let auth = ''

				if (this.$q.platform.is.capacitor) auth = getAuth()
				else auth = this.$webAuth

				signInWithCustomToken(auth, response.data.user_firebase_token)
					.then(() => {
						if (this.$q.platform.is.capacitor) this.setUserDeviceToken()
						else this.getUserData()
					})
					.catch((e) => {
						this.$q.loading.hide()
						console.log(e)
					})
			} else {
				if (this.$q.platform.is.capacitor) this.setUserDeviceToken()
				else this.getUserData()
			}
		},

		setUserDeviceToken() {
			if (this.device_token) {
				let fd = new FormData()
				fd.append('token', this.device_token)
				fd.append('device_type', this.$q.platform.is.android ? 'android' : 'ios')
				this.$axios
					.post('/etraining_login/set_user_device_token/', fd)
					.then((response) => {
						this.getUserData()
					})
					.catch((e) => {
						console.log(e)
						this.getUserData()
					})
			} else this.getUserData()
		},

		getUserData() {
			this.$axios
				.get('/accounts/read_user_data/')
				.then(async (response) => {
					let d = response.data

					this.$store.dispatch('common/SET_USER_DATA', [
						d.accept_terms_and_conditions,
						d.email,
						d.full_name,
						d.has_mandatory_surveys,
						d.id,
						d.id_user_campaign_selected,
						d.id_user_client_country_selected,
						d.id_user_client_profile,
						d.id_user_client_selected,
						d.id_user_language_selected,
						d.is_superuser,
						d.user_client_module_items,
						d.user_clients,
						d.user_firebase_document,
						d.user_firebase_document_ranking_areas,
						d.user_image,
						d.user_reward_campaign,
						d.user_branches,
						d.user_campaigns,
						d.status,
						d.accept_cookies_policy,
						d.has_mandatory_drills,
					])

					if (this.$q.platform.is.ios) {
						await Storage.set({
							key: 'id_user_client_selected',
							value: JSON.stringify(d.id_user_client_selected),
						})
					}

					if (
						this.register_store.default_password &&
						this.register_store.default_password === this.password
					) {
						this.$store.dispatch('common/SET_USER_CHANGE_PASSWORD', [true])
					} else {
						this.$store.dispatch('common/SET_USER_CHANGE_PASSWORD', [false])
					}

					// Status 16 indica que o usuário precisa completar o cadastro
					if (d.status === 16) {
						// Redireciona o usuário para a página de Onboarding para completar o cadastro
						this.$router.replace({
							name: 'onboarding',
						})

						this.$q.loading.hide()
						return
					}

					if (this.$route.name === 'portfolio_course') {
						this.$router.replace({
							name: 'course',
							params: { id: this.$route.params.slug.split('-id-')[1] },
						})
					} else {
						let obj = this.clients.find((obj) => obj.id === response.data.id_user_client_selected)
						if (obj) {
							if (JSON.stringify(this.redirect_url) !== '{}') {
								if (this.$route.name == 'webservice-login') {
									let hasAccess = false
									if (this.redirect_url.id) {
										if (this.redirect_url.module === 'library_single') {
											hasAccess = obj?.[`has_library`]
										} else if (this.redirect_url.module === 'news_single') {
											hasAccess = obj?.[`has_news`]
										} else if (this.redirect_url.module == 'webinar') {
											hasAccess = obj?.[`has_webcasts`]
										} else {
											hasAccess = obj?.[`has_${this.redirect_url.module}s`]
										}
									} else {
										if (this.redirect_url.module == 'webinars') {
											hasAccess = obj?.[`has_webcasts`]
										} else if (this.redirect_url.module == 'profile') {
											hasAccess = obj?.[`has_profile`]
										} else {
											hasAccess = obj?.[`has_${this.redirect_url.module}`]
										}
									}
									if (hasAccess) {
										this.$router.replace({
											name: this.redirect_url.module,
											params: { id: this.redirect_url.id },
										})
									} else {
										this.$router.replace({
											name: obj.home_route,
										})
									}
								} else {
									this.$router.replace({
										name: obj.home_route,
										query: this.redirect_url,
									})
								}
							} else if (obj) {
								this.$router.replace({ name: obj.home_route })
							} else if (obj.home_route) {
								this.$router.replace({ name: obj.home_route })
							} else {
								if (obj.has_courses) {
									this.$router.replace({ name: 'courses' })
								} else if (obj.has_trails) {
									this.$router.replace({ name: 'trails' })
								} else if (obj.has_library) {
									this.$router.replace({ name: 'library' })
								}
							}
						} else {
							this.$router.replace({ name: 'courses' })
						}
					}
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		getUserToken() {
			this.$q.loading.show()
			let data = {
				token: this.redirect_token,
			}

			this.$axios
				.post('/webservices/check_user_token/', data)
				.then((response) => {
					this.$store.dispatch('redirect/SET_TOKEN', [''])
					this.setUserData(response)
				})
				.catch((e) => {
					this.$q.notify({
						message: this.$t('error_logging_in_check_the_user_and_password_entered'),
						type: 'negative',
						icon: 'fal fa-ban',
					})
					this.$q.loading.hide()
					console.log(e)
				})
		},

		loginAzure() {
			this.$axios
				.get('/webservices/azure-login-link/')
				.then((response) => {
					window.open(response.data.azure_login_link, '_self')
				})
				.catch((e) => {
					console.log(e)
				})
		},

		async redirectToIosApp(token = null) {
			if (token) {
				await window.open(`${process.env.PROJECT_FOLDER}://token=${token}`, '_self')
			} else {
				await window.open(`${process.env.PROJECT_FOLDER}://`, '_self')
			}
		},
	},

	created() {
		if (this.$route.name === 'login_redirect_v2') {
			if (this.$route.query.at) {
				this.$q.loading.show()

				this.$store.dispatch('common/SET_USER_TOKEN', [this.$route.query.at])

				let headers = {
					headers: {
						'content-type': 'application/json',
						authorization: 'Bearer ' + this.$route.query.at,
						'X-PNSC': this.$route.query.at
					},
				}

				this.$axios
					.post('/etraining_login/tswap/', {}, headers)
					.then((response) => {
						this.setUserData(response)
					})
					.catch((e) => {
						console.log(e)
					})
			}
		} else if (this.$route.name === 'webservice-login') {
			// Redirecionamento para app ios quando é redirect SSO
			if (this.$q.platform.is.safari && this.$q.platform.is.mobile) {
				this.redirectToIosApp(this.$route.params.token)
				return
			}
			this.$store.dispatch('redirect/SET_TOKEN', [this.$route.params.token])
			this.getUserToken()
		} else if (this.$route.name === 'webservice-login-unauthenticated') {
			this.support_email = this.$route.query.email
		} else if (this.redirect_token) {
			this.getUserToken()
		}
	},

	mounted() {
		this.$mitt.on('forceLogin', ({ username, password }) => {
			this.username = username
			this.password = password
			this.login()
		})
	},

	beforeDestroy() {
		this.$mitt.off('forceLogin')
	},

	validations() {
		return {
			username: { required },
			password: { required },
		}
	},
}
</script>

<style lang="scss" scoped>
.login-button {
	border-radius: 1.5rem;
}

.word-wrap {
	word-wrap: break-word;
}

.underline {
	text-decoration: underline;
}
</style>
